import { useState } from "react";
import { useBranding } from "@/lib/branding";

/**
 * The organisation's logo (or square icon) as set in Settings > General > Branding.
 * `fallback` is the bundled image used when nothing has been uploaded or it fails to load.
 * While the branding lookup is in flight the fallback is rendered hidden, so the layout does not
 * jump and the old image never flashes.
 */
export default function BrandLogo({ variant = "logo", fallback, alt = "Prydes Support", className = "", ...rest }) {
  const { loaded, logoUrl, iconUrl } = useBranding();
  const [failed, setFailed] = useState(false);
  // The square icon falls back to the wide logo (scaled by the caller's classes) before the bundled icon.
  const uploaded = variant === "icon" ? (iconUrl || logoUrl) : logoUrl;
  const src = loaded && uploaded && !failed ? uploaded : fallback;
  return (
    <img
      src={src}
      alt={alt}
      className={`${className}${loaded ? "" : " invisible"}`}
      onError={() => { if (uploaded) setFailed(true); }}
      {...rest}
    />
  );
}
